'use strict'

import { useAuthStore } from '@/stores'
import Config from '../config'

export const SsoRedirectHandler = {
    verifyAuth: function () {
        const { user } = useAuthStore()
        const isLoggedIn = !!user?.token
        if (!isLoggedIn) {
            if (Config.ENV === 'local') {
                console.log("Authenticate with dev and use localStorage.setItem('user', JSON.stringify({token: '....'})");
                return true;
            }
            document.location = Config.SAML_SSO_URL
            return false
        }
        return true
    }
}
